/**
 * `'database-changed'` event
 * @typedef {Object} DatabaseEvent
 * @property {string} scope - The name of the model
 * @property {Object} method - The model instance
 * @example this.dispatchEvent(new ModelEvent({scope: 'todos', model: todo}));
 */
export class DatabaseEvent extends Event {
  constructor({scope, model, actions}) {
    super('database-changed');
    this.scope = scope;
    this.actions = actions;
  }
}
